import { createVNode as t } from "vue";
const p = (u) => typeof u == "function" ? u() : u, f = (u, {
  slots: e
}) => {
  var n;
  return p(u.condition) ? (n = e.default) == null ? void 0 : n.call(e) : null;
}, C = (u, {
  slots: e
}) => t(f, u, {
  default: () => {
    var n;
    return [(n = e.default) == null ? void 0 : n.call(e)];
  }
}), _ = (u, {
  slots: e
}) => t(f, {
  condition: !0
}, {
  default: () => {
    var n;
    return [(n = e.default) == null ? void 0 : n.call(e)];
  }
}), y = (u, {
  slots: e
}) => t(f, {
  condition: !0
}, {
  default: () => {
    var n;
    return [(n = e.default) == null ? void 0 : n.call(e)];
  }
}), o = (u, {
  slots: e
}) => t(f, {
  condition: !0
}, {
  default: () => {
    var n;
    return [(n = e.default) == null ? void 0 : n.call(e)];
  }
}), R = (u, {
  slots: e
}) => {
  var d;
  const n = (d = e.default) == null ? void 0 : d.call(e);
  return p(u.condition) ? t(o, null, {
    default: () => [n == null ? void 0 : n.find((r) => r.type === o)]
  }) : t(y, null, {
    default: () => [n == null ? void 0 : n.find((r) => r.type === y)]
  });
}, g = (u, {
  slots: e
}) => {
  var i;
  const n = (i = e.default) == null ? void 0 : i.call(e), d = n == null ? void 0 : n.find((a) => {
    var c;
    return a.type === C && p((c = a.props) == null ? void 0 : c.condition);
  }), r = n == null ? void 0 : n.find((a) => a.type === _);
  return d ?? r ?? null;
}, v = (u, {
  slots: e
}) => t(f, u, {
  default: () => {
    var n;
    return [(n = e.default) == null ? void 0 : n.call(e)];
  }
}), w = "0.0.4";
export {
  C as Case,
  _ as Default,
  y as Else,
  R as If,
  g as Switch,
  o as Then,
  v as When,
  w as version
};
//# sourceMappingURL=index.es.js.map
